import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { Observable, Observer } from 'rxjs';
import { Account } from 'src/app/shared/models/account.model';
import { NotaFiscalReplica } from 'src/app/shared/models/nota-fiscal-replica.model';
import { INotaFiscal, NotaFiscal } from 'src/app/shared/models/nota-fiscal.model';
import { ReplicaImagem } from 'src/app/shared/models/replica-imagem.model';
import { Status } from 'src/app/shared/models/status.model';
import { AccountService } from 'src/app/shared/services/account.service';
import { NotaFiscalService } from 'src/app/shared/services/nota-fiscal.service';
import { DataUtils, FileLoadError } from 'src/app/shared/util/data-util.service';
import { EventManager } from 'src/app/shared/util/event-manager.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MaterialFileInputModule } from 'ngx-custom-material-file-input';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { TitleCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-car-replica',
    templateUrl: './car-replica.component.html',
    styleUrls: ['./car-replica.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MaterialFileInputModule, MatIconButton, MatIcon, TitleCasePipe, DatePipe, TranslateModule]
})
export class CarReplicaComponent implements OnInit {

  isLoading = false;
  isSaving = false;
  notaFiscal: NotaFiscal = {};
  admin: Account;
  replica: NotaFiscalReplica = {};

  statusValues = Object.keys(Status);

  editForm = this.fb.group({
    id: [],
    notaFiscal: [],
    descricao: ['', Validators.required],
    imagens: [],
  });

  constructor(
    protected accountService: AccountService,
    protected dataUtils: DataUtils,
    protected eventManager: EventManager,
    protected notaFiscalService: NotaFiscalService,
    protected fb: FormBuilder,
    public dialogRef: MatDialogRef<CarReplicaComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.accountService.query().subscribe(
        (res: HttpResponse<Account[]>) => {
            this.admin = res.body.filter(x => x.id === 1)[0];
        }
    )
    this.notaFiscalService.find(this.data).subscribe(
      (res: HttpResponse<INotaFiscal>) => {
        this.notaFiscal = res.body ?? null;

      },
      () => {
        this.isLoading = false;
      }
    );
  }

  openFile(base64String: string, contentType: string | null | undefined): void {
    return this.dataUtils.openFile(base64String, contentType);
  }

  openFileKML(data: string, contentType: string | null | undefined) {
    contentType = contentType ?? '';
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: 'kml'});
    const anchor = document.createElement('a');
    anchor.download = data.substring(0, 5)+".kml";
    anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
    anchor.click();
  }

  novaImagem(): void {
    if (!this.replica.imagens) {
      this.replica.imagens = [];
    }
    this.replica.imagens.push(new ReplicaImagem());
  }


  loadFileToForm(event: Event, field: string, isImage: boolean, i: number): Observable<void> {
    return new Observable((observer: Observer<void>) => {
      const eventTarget: HTMLInputElement | null = event.target as HTMLInputElement | null;
      if (eventTarget?.files?.[0]) {
        const file: File = eventTarget.files[0];
        this.dataUtils.toBase64(file, (base64Data: string) => {
          this.replica.imagens![i].imagem = base64Data;
          this.replica.imagens![i].imagemContentType = file.type;
          observer.next();
          observer.complete();
        });
        // }
      } else {
        const error: FileLoadError = {
          message: 'Could not extract file',
          key: 'could.not.extract',
          params: { event },
        };
        observer.error(error);
      }
    });
  }

  setFileData(event: Event, field: string, i: number): void {
    this.loadFileToForm(event, field, true, i).subscribe({
      error: (err: FileLoadError) =>
        alert('jiantanApp.error ' + err),
    });
  }

  removeFile(i: number){
    this.replica.imagens.splice(i, 1);
  }

  save(): void {
    if(this.notaFiscal.status === Status.APROVADA){
        alert('CAR já aprovado');
        return;
    }
    this.replica.dataCriacao = new Date(Date.now());
    this.replica.status = Status.AGUARDANDO_RESPOSTA;
    this.replica.descricao = this.editForm.get(['descricao'])!.value;
    this.replica.userCriadoPor = this.admin;

    for(let i: number = 0; i < this.replica.imagens.length; i++){
        if(this.replica.imagens[i].imagem === undefined || this.replica.imagens[i].imagemContentType === undefined){
            this.replica.imagens.splice(i, 1);
      }
    }

    if(!this.editForm.valid){
        alert('Insira uma  descrição.');
        return;
    }
    if(!this.replica.imagens || this.replica.imagens.length === 0){
        alert('Insira uma imagem.');
        return;
    }

    const notaFiscal = this.notaFiscal;
    notaFiscal.status = Status.AGUARDANDO_RESPOSTA;
    if (!notaFiscal.replicas) {
      notaFiscal.replicas = [];
    }
    notaFiscal.replicas.push(this.replica);

    // removendo a lista de imagens para não tentar salvar novamente no cascade
    if (notaFiscal.imagens) {
        delete notaFiscal['imagens'];
    }

    this.isSaving = true;

    this.notaFiscalService.update(notaFiscal).subscribe(
      () => {
        this.onNoClick();
        this.isSaving = false;
      },
      (err) => {

        alert('error: ' + err.message);
        this.isSaving = false;
    }
    );

  }

}
